import React, { useEffect } from 'react';

import { ReceivePacketCallback } from '../../../types';
import { useXpointDownloadSDK } from './useXpointDownloadSDK';
import { useXpointSubscription } from './useXpointSubscription';
import { useXpointRequestPacket } from './useXpointRequestPacket';
import { useXpointConnect } from './useXpointConnect';

import * as Types from '../types';

export const useXpointIntegration = ({
    sdk,
    enable,
    sdkUrl,
    transactionID,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket,
    geolocationType
}: {
    sdk: Types.XPointSDKInstance | null;
    enable: boolean;
    sdkUrl: string;
    transactionID: string | null;
    useTransparentPopup: boolean;
    onConnect: CallableFunction;
    setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
    receivePacket: ReceivePacketCallback;
    geolocationType: string;
}) => {
    const downloadXpointSDK = useXpointDownloadSDK({ sdkUrl });
    const xpointConnect = useXpointConnect({
        sdk,
        onConnect,
        useTransparentPopup,
        setShowOverlay,
        geolocationType
    });
    const requestXpointPacket = useXpointRequestPacket({
        sdk,
        transactionID
    });

    useXpointSubscription({
        sdk,
        enable,
        transactionID,
        receivePacket,
        geolocationType
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        xpointConnect();
    }, [sdk, enable, xpointConnect]);

    return {
        requestXpointPacket,
        downloadXpointSDK
    };
};
